export default __webpack_public_path__ + "Mask-group-19.355574.svg";